<template>
  <div data-cy="buscadorHotelesPanel">
    <v-form @submit.prevent="onSubmit" autocomplete="off">
      <v-container fluid class="px-0">
        <v-layout :[plano]="true">
          <v-flex xs12 md3>
            <label for="inputSalReg" class="text-white sr-only"
              >Salida - Regreso:</label
            >
            <vc-date-picker
              is-expanded
              mode="range"
              :min-date="formConfig.picker.startDate"
              :max-date="formConfig.picker.endDate"
              v-model="startingDates"
              color="red"
              @input="selected"
              :input-props="{ placeholder: 'Llegada - Salida' }"
              :popover="{ visibility: 'click' }"
              :select-attribute="selectDragAttribute"
              :drag-attribute="selectDragAttribute"
              @drag="dragValue = $event"
              @dayclick="clickDay"
              :disabled-dates="rangos.rangoMaximoDeshabilitado"
              @popoverDidHide="cerroPop"
            >
              <input
                id="date"
                slot-scope="{ inputProps, inputEvents, isDragging }"
                :class="[
                  `input-as elevation-1 text--grey lighten-2 caption py-2 px-3 ${
                    isDragging ? 'text-gray-400' : 'text-gray-700'
                  }`
                ]"
                v-bind="inputProps"
                v-on="inputEvents"
              />
              // eslint-disable-next-line prettier/prettier
              <div slot="day-popover" slot-scope="{ format }">
                <!--format si es usado, al exjutar lnit fixx muestra que no-->
                {{
                  dragValue
                    ? mensajePicker(dragValue.start, dragValue.end)
                    : mensajePicker(startingDates.start, startingDates.end)
                }}
              </div>
            </vc-date-picker>
            <v-input
              v-model="inputFechas"
              v-validate="'required'"
              name="fechas"
              :error-messages="errors.first('fechas')"
            ></v-input>
          </v-flex>
          <v-flex xs12 md3>
            <label for="id-select" class="text-white sr-only">Destinos:</label>
            <v-autocomplete
              v-model="form.destino"
              :items="formConfig.destinos"
              solo
              color="blue-grey lighten-2"
              label="Destino"
              item-text="text"
              item-value="value"
              clearable
              dense
              @change="destinoSelected"
              v-validate="'required'"
              name="destino"
              :error-messages="errors.first('destino')"
              data-cy="htlDestino"
              id="htlDestino"
            >
              <template v-slot:label>
                <small>Escriba hotel o destino</small>
              </template>
              <template v-slot:selection="data">
                <small class="caption">
                  {{
                    `${data.item.text}, ${data.item.sufijo}`
                      | truncateString(39)
                  }}
                </small>
              </template>
              <template v-slot:item="data">
                <div>
                  <template v-if="data.item.header">
                    <v-list-tile-content class="bk-header">
                      <p class="red--text">{{ data.item.header }}</p>
                    </v-list-tile-content>
                  </template>
                  <template v-else-if="!data.item.header">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span class="font-weight-medium">
                          {{ titulo2Singular(data.item.titulo) }}
                        </span>
                        |
                        <span class="font-weight-regular">
                          {{ data.item.text }}
                        </span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>{{
                        data.item.sufijo
                      }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </div>
              </template>
              <template slot="no-data">
                <span class="text-center">Destino no encontrado</span>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 md3>
            <v-select
              :items="categoriasFiltradas"
              solo
              name="categoria"
              v-model="form.categoria"
              v-validate="'required'"
              :error-messages="errors.first('categoria')"
              data-vv-as="categoria"
              id="categoria"
              placeholder="Seleccione un destino"
            >
              <template v-slot:selection="data">
                <small>{{ data.item.text }}</small>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs12 md2>
            <SelectorOcupacion
              :ocupacion="formConfig.ocupacion"
            ></SelectorOcupacion>
          </v-flex>
          <v-flex xs12 md1>
            <v-btn
              type="submit"
              block
              color="primary"
              dark
              large
              class="mt-0"
              style="height: 48px;"
              data-cy="submitBusquedaHtl"
              >Buscar</v-btn
            >
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex";
import SelectorOcupacion from "@/components/utiles/SelectorOcupacion.vue";
import RqHoteles from "@/assets/js/class/RqHoteles.js";

import moment from "moment";
import { debounce } from "debounce";
export default {
  name: "buscadorHoteles",
  props: {
    plano: {
      validator: function(value) {
        return value;
      }
    }
  },
  components: {
    SelectorOcupacion
  },
  created() {},
  mounted() {
    this.prepararForm();
    this.fixEstilosForm();
  },
  beforeCreate() {},
  methods: {
    destinoSelected(sel) {
      this.form.destino = sel;
      document.getElementById("categoria").focus();
      document.getElementById("categoria").click();
    },
    onSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.doSubmit();
        }
      });
    },
    async doSubmit() {
      await this.$store.dispatch("app/setBuscando", true);
      this.form["ocupacion"] = this.formConfig.ocupacion;
      this.$store.dispatch("app/setFormSave", this.form);
      let map = new RqHoteles(this.form);
      const dataBusqueda = map.armarParametros2Espera(
        this.$router.currentRoute.name,
        "No se encontraron hoteles, será redirigido al buscador",
        "resultadoHoteles",
        "resultadoHoteles"
      );
      this.$router.push({ name: "buscandox", params: { data: dataBusqueda } });
    },
    updateFromTo(value) {
      this.form.fromTo.startDate = value.startDate;
      this.form.fromTo.endDate = value.endDate;
    },
    tomarIn(indate) {
      let checkin = moment(indate).format("YYYY-MM-DD");
      this.form.checkin = checkin;
    },
    tomarOut(outdate) {
      let checkout = moment(outdate).format("YYYY-MM-DD");
      this.form.checkout = checkout;
      if (this.form.checkin != null && this.form.checkout != null) {
        this.inputFechas = `${this.form.checkin}  ${this.form.checkout}`;
      }
      this.fixEstilosForm();
    },
    titulo2Singular(titulo) {
      let fixed = "";
      switch (titulo) {
        case "Ciudades":
          fixed = "Ciudad";
          break;
        case "Zonas":
          fixed = "Zona";
          break;
        case "Hoteles":
          fixed = "Hotel";
          break;
        default:
          fixed = titulo;
          break;
      }
      return fixed;
    },
    prepararForm() {
      try {
        this.ready = false;
        const formSaved = this.$store.getters["app/getFormSaved"];
        if (formSaved === null) {
          this.ready = true;
          return;
        }
        this.form.checkin = formSaved.checkin;
        this.form.checkout = formSaved.checkout;
        this.form.destino = formSaved.destino;
        this.form.categoria = formSaved.categoria;
        this.inputFechas = `${this.form.checkin}  ${this.form.checkout}`;
      } catch (e) {
        console.log(e);
      } finally {
        this.ready = true;
      }
    },
    prepararFecha(string) {
      if (string === null) {
        return null;
      }
      let momented = moment(string).toDate();
      return momented;
    },
    fixEstilosForm() {
      this.$nextTick(function() {
        let inputs = document.getElementsByClassName("datepicker__input");
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].style.padding = "0";
          inputs[i].style.padding = "10px 0 10px 20px";
          inputs[i].style.fontSize = "12px";
        }
      });
    },
    selected(data) {
      let checkin = moment(data.start).format("YYYY-MM-DD");
      this.form.checkin = checkin;
      let checkout = moment(data.end).format("YYYY-MM-DD");
      this.form.checkout = checkout;
      const esta = this.rangos.inicioDeshabilitado.findIndex(
        i => i.diff(moment(data.end), "days") === 0
      );
      if (esta != -1) {
        data.end = null;
        return;
      }
      if (this.form.checkin != null && this.form.checkout != null) {
        this.isInDate = true;
        this.inputFechas = `${this.form.checkin}  ${this.form.checkout}`;
        document.getElementById("htlDestino").focus();
        document.getElementById("htlDestino").click();
      }
      this.rangos = { rangoMaximoDeshabilitado: [], inicioDeshabilitado: [] };
    },
    mensajePicker(din, dout) {
      const fechaOut = moment(dout);
      const habilitado = this.rangos.inicioDeshabilitado.findIndex(
        d => moment(d).diff(fechaOut, "days") === 0
      );
      if (habilitado === -1) {
        return this._$diffDias(din, dout);
      }
      return `Debe seleccionar mínimo ${
        this.formConfig.picker.minNoches
      } noches`;
    },
    clickDay(day) {
      if (!day.isDisabled === false) {
        return;
      }
      if (!this.isInDate) {
        return;
      }
      this.isInDate = !this.isInDate; // DESPUES DEL IF
      this.rangos = this._$fechasNoDisponiblesBuscadores(
        day.date,
        this.formConfig.picker.minNoches - 1,
        this.formConfig.picker.maxNoches
      );
    },
    cerroPop() {
      if (!this.startingDates) {
        this.isInDate = true;
      }
    },
    setForm: debounce(function(data) {
      this.$store.dispatch("app/saveFormConfigHtl", data);
    }, 1),
    categoriasDestino: function() {
      if (this.form.destino === null) {
        return [];
      }
      let _this = this;
      this.form.isDc = this.formConfig.destinos.some(
        d => this.form.destino == d.value && d.isDC
      );
      let categorias = this.categorias
        .filter(c => {
          return c.isDc === this.form.isDc && c.destino === _this.form.destino;
        })
        .flatMap(c => c.lista);
      if (categorias.length === 0) {
        categorias = [
          { value: 0, text: "Todas las categorias" },
          { value: 1, text: "1 estrella" },
          { value: 2, text: "2 estrellas" },
          { value: 3, text: "3 estrelas" },
          { value: 4, text: "4 estrellas" },
          { value: 5, text: "5 estrellas" }
        ];
      }
      let preConfig = JSON.parse(JSON.stringify(this.formConfig));
      preConfig.categorias = categorias;
      this.setForm(preConfig);
      this.categoriasFiltradas = categorias;
    }
  },
  data() {
    return {
      categoriasFiltradas: [],
      inputFechas: null,
      classConfig: null,
      form: {
        checkin: null,
        checkout: null,
        destino: null,
        categoria: 0,
        isTarifario: false,
        isDc: false
      },
      startingDates: null,
      destionsFiltros: [],
      selectedDestino: null,
      ready: false,
      dragValue: null,
      rangos: { rangoMaximoDeshabilitado: [], inicioDeshabilitado: [] },
      isInDate: true,
      categorias: [
        {
          destino: "z-379936",
          isDc: false,
          lista: [
            { value: 0, text: "Todos", alt: null },
            { value: 1, text: "Económico", alt: "economicos" },
            { value: 2, text: "Moderado", alt: "moderados" },
            { value: 3, text: "Lujo", alt: "lujo" },
            { value: 4, text: "Villa", alt: "villas" },
            { value: 5, text: "Camping", alt: "camping" }
          ]
        },
        {
          destino: "z-379936",
          isDc: true,
          lista: [
            { value: 10, text: "Económico", alt: "economicos" },
            { value: 11, text: "Moderado", alt: "moderados" },
            { value: 12, text: "Lujo", alt: "lujo" },
            { value: 13, text: "Villa", alt: "villas" },
            { value: 15, text: "Camping", alt: "camping" }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapGetters("app", {
      formConfig: "getFormConfigHtl"
    }),
    selectDragAttribute() {
      return {
        popover: {
          visibility: "hover",
          isInteractive: false // Defaults to true when using slot
        }
      };
    }
  },
  watch: {
    inputFechas: function() {
      let _this = this;
      setTimeout(function() {
        _this.fixEstilosForm();
      }, 1);
    },
    "form.destino": {
      handler: function() {
        this.categoriasDestino();
      },
      immediate: true,
      deep: true
    }
  }
};</script
>Plan de comida deluxe
<style scoped>
.fix_text_dt-as {
  padding: 0;
}
</style>
